@use "@flixbus/honeycomb-react/dist/scss/honeycomb-helpers.scss";

.panelWrapper {
  > div {
    max-width: 1200px;
    width: 90vw;
  }
}

.headerContent {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.headerLeft {
  display: flex;
  align-items: center;
  gap: var(--hcr-spacing-3);
}

.headerNav {
  margin-bottom: 0;
}

.headerTitle {
  white-space: nowrap;
}

.headerIcons {
  display: flex;
  align-items: center;
  gap: var(--hcr-spacing-2);
  margin-right: var(--hcr-spacing-2);
}

.navSection {
  margin-bottom: var(--hcr-spacing-4);
}

.formulaContainer {
  display: flex;
  flex-wrap: wrap;
  gap: var(--hcr-spacing-1);
  margin-top: var(--hcr-spacing-4);
}

.footer {
  border-top: 1px solid var(--hcr-line-primary-color);
}

.confirmPopup {
  z-index: 1300;
}
